/**
 * Extrahiert den ursprünglichen Dateinamen aus einer Supabase Storage URL
 * Unterstützt verschiedene Formate:
 * - Neues Format: {path}/{originalName}_{timestamp}_{index}.{ext}
 * - Standard Format: beliebiger Dateiname ohne spezielle Struktur
 */
export function extractOriginalFileName(url: string): string {
  try {
    const fileName = url.split('/').pop()?.split('?')[0];
    if (!fileName) return 'Dokument';
    
    // Entferne Dateiendung für die Analyse
    const lastDotIndex = fileName.lastIndexOf('.');
    const extension = lastDotIndex !== -1 ? fileName.substring(lastDotIndex) : '';
    const nameWithoutExt = lastDotIndex !== -1 
      ? fileName.substring(0, lastDotIndex) 
      : fileName;
    
    // Spalte nach Underscores auf
    const parts = nameWithoutExt.split('_');
    
    if (parts.length === 0) return fileName; // Fallback: vollständiger Dateiname
    
    // Prüfe auf neues Upload-Format: {name}_{timestamp}_{index}
    // Timestamp = 13 Stellen, Index = 1-2 Stellen
    if (parts.length >= 3) {
      const lastPart = parts[parts.length - 1];
      const secondLastPart = parts[parts.length - 2];
      
      // Prüfe ob letzter Part ein Index ist (kleine Zahl 0-99)
      // und zweitletzter Part ein Timestamp ist (13 Stellen)
      const isLastPartIndex = /^\d{1,2}$/.test(lastPart);
      const isSecondLastPartTimestamp = /^\d{13}$/.test(secondLastPart);
      
      if (isLastPartIndex && isSecondLastPartTimestamp) {
        // Neues Format erkannt: Extrahiere alles vor timestamp_index
        const originalName = parts.slice(0, -2).join('_');
        try {
          return decodeURIComponent(originalName) + extension;
        } catch {
          return originalName + extension;
        }
      }
    }
    
    // WICHTIG: Kein spezielles Format erkannt - gib den VOLLSTÄNDIGEN Dateinamen zurück
    // (nicht parts[parts.length - 2] wie vorher, was zu Fehlern führte)
    try {
      return decodeURIComponent(fileName);
    } catch {
      return fileName;
    }
  } catch {
    return 'Dokument';
  }
}
